module.exports = __webpack_public_path__ + "static/media/imgPrice.dbfddc47.svg";